import { useEffect, useState } from "react";

export const AdminLogin = ({ initial, onSubmit, notice }) => {
  const [pwd, setPwd] = useState(initial);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!pwd) return;
    setBusy(true);
    await onSubmit(pwd);
    setBusy(false);
  };

  useEffect(() => {
    if (initial) submit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form onSubmit={submit} className="ob-admin-login" data-testid="admin-login-form">
      <div className="ob-field">
        <label htmlFor="admin-password" className="ob-label">Mot de passe administrateur</label>
        <input
          id="admin-password"
          type="password"
          value={pwd}
          autoComplete="current-password"
          onChange={(e) => setPwd(e.target.value)}
          className="ob-input"
          data-testid="admin-password-input"
        />
        {notice && <p className="ob-hint" data-testid="admin-login-notice">{notice}</p>}
      </div>
      <button type="submit" className="ob-btn" disabled={busy} data-testid="admin-login-button">
        {busy ? "Ouverture" : "Ouvrir"}
      </button>
    </form>
  );
};
